const state = {
  id: 0,
  title: '',
  pageTitle: '',
  metaDescription: '',
  contentTypeName: '',
  textSnippet: '',
  mainImage: 'https://via.placeholder.com/739x554',
  publishedAt: new Date(),
  slug: '',
  articleContents: [],
  nextArticle: {},
  products: [],
  variants: [],
  images: [],
  imageCollectionImages: [],
  tags: [],
  loading: true
}

const mutations = {
  setImageCollectionImages (state, images) {
    state.imageCollectionImages = images
  },
  setImages (state, images) {
    state.images = images
  },
  setArticle (state, { id, title, contentTypeName, textSnippet, mainImage, publishedAt, slug, pageTitle, metaDescription }) {
    state.id = id
    state.title = title
    state.contentTypeName = contentTypeName
    state.textSnippet = textSnippet
    state.mainImage = mainImage
    state.publishedAt = new Date(publishedAt)
    state.slug = slug
    state.metaDescription = metaDescription
    state.pageTitle = pageTitle
  },
  setArticleContents (state, articleContents) {
    state.articleContents = articleContents
  },
  setProducts (state, products) {
    state.products = products
  },
  setVariants (state, variants) {
    state.variants = variants
  },
  setTags (state, tags) {
    state.tags = tags
  },
  setLoading (state, isLoading) {
    state.loading = isLoading
  },
  setNextArticle (state, nextArticle) {
    state.nextArticle = nextArticle
  }
}

export default { namespaced: true, state, mutations }
